export const FormSpecialSubmissionErrorWidgetId = 'FormSpecialSubmissionErrorWidget';
